import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { NextGenCollection, NextGenToken } from "@/entities/INextgen";
import styles from "../NextGen.module.scss";
import SlideshowHeader from "./hooks/SlideshowHeader";
import TokenSlideshow from "./hooks/TokenSlideshow";
interface Props {
  readonly collection: NextGenCollection;
  readonly initialTokens?: NextGenToken[];
}
export default function NextGenCollectionSlideshow(props) {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.collection.name) {
    t0 = <SlideshowHeader collectionName={props.collection.name} />;
    $[0] = props.collection.name;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.collection.id || $[3] !== props.initialTokens) {
    t1 = <TokenSlideshow collectionId={props.collection.id} initialTokens={props.initialTokens} />;
    $[2] = props.collection.id;
    $[3] = props.initialTokens;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <Container fluid={true} className={styles.slideshowContainer}><Row><Col><Container className="pt-3 pb-3">{t0}{t1}</Container></Col></Row></Container>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}